var React = require('react');

function LogoShapeRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M195.994 91.5793V-0.000244141L30.516 112.539C21.1481 118.878 13.458 127.497 8.13297 137.626C2.80791 147.754 0.0137092 159.077 0 170.583V262.162L165.478 149.623C174.807 143.243 182.467 134.615 187.787 124.496C193.107 114.376 195.925 103.074 195.994 91.5793Z","fill":"#7BE4AF"}));
}

LogoShapeRight.defaultProps = {"viewBox":"0 0 196 263"};

module.exports = LogoShapeRight;

LogoShapeRight.default = LogoShapeRight;
